import { Link } from "react-router-dom"
import { FiArrowRight } from "react-icons/fi"

export type MediaSite = { id: string; name: string; configured: boolean }

type Props = { sites: MediaSite[] }

export default function MediaPicker({ sites }: Props) {
 // Pristjek keeps its existing routes and workflows; other sites use the standard workspace.
 const choices = [
  { id: "eb-pristjek", name: "Ekstrabladet Pristjek", configured: true },
  ...sites.filter(site => site.id !== "eb-pristjek"),
 ]
 return (
  <section className="media-picker" aria-labelledby="media-picker-title">
   <header className="media-picker-heading">
    <div>
     <span className="media-picker-eyebrow">EB / MEDIER</span>
     <h1 id="media-picker-title">Her begynder næste historie.</h1>
     <p>Vælg dit medie, og saml kladder, kalender og publicering ét sted.</p>
    </div>
    <span className="media-picker-count">{choices.length} {choices.length === 1 ? "medie" : "medier"}</span>
   </header>

   <div className={`media-picker-grid${choices.length === 1 ? " media-picker-grid-single" : ""}`}>
     {choices.map(site => (
      <Link key={site.id} to={site.id === "eb-pristjek" ? "/eb-pristjek/products" : `/eb/media/${site.id}`} className={`media-site-card${site.id === "eb-pristjek" ? " media-site-pristjek" : ""}`} aria-label={`Åbn medie: ${site.name}`}>
       <div className="media-site-cover" aria-hidden="true">
        <div className="media-site-paper">
         <div className="media-site-masthead">
          {site.id === "eb-pristjek" ? <img src="/media/ekstrabladet-logo.svg" alt="" /> : site.id === "dinavis" ? <img src="/media/dinavis-logo.svg" alt="" /> : <span className="media-site-initial">{site.name.slice(0, 1)}</span>}
          <span>{site.id === "eb-pristjek" ? "Pristjek" : site.name}</span>
         </div>
         <div className="media-site-paper-rule" />
         <div className="media-site-paper-headline"><span /><span /></div>
         <div className="media-site-paper-columns">
          <div className="media-site-paper-image"><span /></div>
          <div className="media-site-paper-lines"><span /><span /><span /><span /><span /></div>
         </div>
         <div className="media-site-paper-footer"><span /><span /><span /></div>
        </div>
       </div>
       <div className="media-site-content">
        <h2>{site.name}</h2>
        <div className="media-site-card-bottom">
         <span className="media-site-open">Åbn medie <FiArrowRight aria-hidden="true" /></span>
         {!site.configured && <span className="media-site-pending"><span /> Afventer opsætning</span>}
        </div>
       </div>
      </Link>
     ))}
   </div>
  </section>
 )
}
